





























































































import {Component, Prop, PropSync, Ref, Watch} from 'vue-property-decorator'
import {Getter, Action} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {SelectWings,
  ToggleWings,
  PriceWings,
  NumberWings,
  NewPriceWings
} from "wings-ui-components";
import {TariffZoneFilter, TarificationTransports, TarificationTypes} from "@/store/tarification/types";
import { notifyError } from '@/utils/notify-helper';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {
    SelectWings,
    ToggleWings,
    PriceWings,
    NumberWings,
    NewPriceWings
  }
})
export default class TariffZonesFilter extends BaseFilter<TariffZoneFilter> {

  @Ref('validator') validator: any;

  @PropSync('show') is_show!: boolean;
  @PropSync('partner_id') partnerId!: number|undefined;
  @PropSync('operator_id') operatorId!: number|undefined;
  @Prop() transport!: TarificationTransports;
  @Prop() type!: TarificationTypes;
  @Getter("partners") partnersList: any;
  @Getter("serviceProviders") serviceProvidersList: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getTariffZones") actionGetTariffZones: any;

  statusList:number[] = [1,0];

  private partnerType: TarificationTypes = TarificationTypes.PARTNER
  private operatorType: TarificationTypes = TarificationTypes.OPERATOR

  defaultFilter(): TariffZoneFilter {
    return {
      name: undefined,
      msisdn: undefined,
      mcc: undefined,
      mnc: undefined,
      price: undefined,
      status: undefined,
    };
  }

  storageItemName(): string {
    return `${this.transport.toLowerCase() + this.type}TariffZoneFilter`;
  }

  created() {
    this.onFilteredAction();
  }

  async onFilteredAction(): Promise<void> {
    if (this.is_show) {
      let valid: boolean = await this.validator.validate();
      if (!valid) {

        // TODO: Костыль, без него не корректно работает фильтр при валидации поля "цена"
        this.sendFilter = this.defaultFilter(); // Это стоит переделать

        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
        return;
      }
    }
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Tariff zone",
        addititional_info: getTranslatedParams({
          ...this.filter,
          ...{ partner: this.partnerId, service_provider: this.operatorId }
        })
      }
      await this.actionGetTariffZones({
        filter: this.filter,
        transport: this.transport.toLowerCase(),
        partner_id: this.partnerId,
        operator_id: this.operatorId,
      });
      await this.actionLog(this.logObject);
    } catch (e){
      this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  @Watch('partnerId')
  onPartnerIdChange(val:any, oldVal:any){
    if (this.type === this.partnerType && !val && oldVal) {
      this.clear();
    } else if (this.type === this.partnerType && val) {
      this.onFilteredAction();
    }
  }

  @Watch('operatorId')
  onOperatorIdChange(val:any, oldVal:any){
    if (this.type===this.operatorType && !val && oldVal) {
      this.clear();
    } else if (this.type===this.operatorType && val) {
      this.onFilteredAction();
    }
  }
}
